import { FC } from "react"
import Skeleton from "../base"

const TAB_WIDTHS = [60, 96, 88, 52, 68]

const FieldPair: FC<{
  labelA: number
  valueA: number
  labelB: number
  valueB: number
}> = ({ labelA, valueA, labelB, valueB }) => (
  <div className="grid grid-cols-2 gap-x-12">
    <div className="space-y-1.5">
      <div
        className="h-3 rounded bg-gray-200"
        style={{ width: `${labelA}px` }}
      />
      <div
        className="h-4 rounded bg-gray-200"
        style={{ width: `${valueA}px` }}
      />
    </div>
    <div className="space-y-1.5">
      <div
        className="h-3 rounded bg-gray-200"
        style={{ width: `${labelB}px` }}
      />
      <div
        className="h-4 rounded bg-gray-200"
        style={{ width: `${valueB}px` }}
      />
    </div>
  </div>
)

const LoanOfficerDetailsSkeleton: FC = () => (
  <div className="h-full bg-white">
    {/* Header */}
    <Skeleton className="px-6 pt-4 pb-5 border-b border-gray-100">
      {/* Breadcrumb */}
      <div className="flex items-center gap-2 mb-4">
        <div className="h-3.5 w-24 rounded bg-gray-200" />
        <div className="h-3 w-2 rounded bg-gray-200" />
        <div className="h-3.5 w-32 rounded bg-gray-200" />
      </div>

      {/* Identity row */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          {/* Avatar */}
          <div className="h-14 w-14 rounded-full bg-gray-200" />
          <div className="space-y-2">
            {/* Name */}
            <div className="h-6 w-48 rounded bg-gray-200" />
            {/* email · ID · NMLS */}
            <div className="flex items-center gap-2">
              <div className="h-3.5 w-44 rounded bg-gray-200" />
              <div className="h-3 w-1 rounded bg-gray-200" />
              <div className="h-3.5 w-16 rounded bg-gray-200" />
              <div className="h-3 w-1 rounded bg-gray-200" />
              <div className="h-3.5 w-24 rounded bg-gray-200" />
            </div>
          </div>
        </div>

        {/* Action buttons */}
        <div className="flex items-center gap-2">
          <div className="h-9 w-28 rounded-lg bg-gray-200" />
          <div className="h-9 w-20 rounded-lg bg-gray-200" />
        </div>
      </div>
    </Skeleton>

    {/* Tabs */}
    <Skeleton className="px-6 border-b border-gray-100">
      <div className="flex gap-6 pt-1">
        {TAB_WIDTHS.map((w, i) => (
          <div key={i} className="pb-3 pt-2">
            <div
              className="h-3.5 rounded bg-gray-200"
              style={{ width: `${w}px` }}
            />
          </div>
        ))}
      </div>
    </Skeleton>

    {/* Content */}
    <Skeleton className="p-6 space-y-4">
      {/* Professional Info card */}
      <div className="rounded-xl border border-gray-100 p-5 space-y-4">
        {/* Card title */}
        <div className="flex items-center gap-2">
          <div className="h-4 w-4 rounded bg-gray-200" />
          <div className="h-4 w-32 rounded bg-gray-200" />
        </div>
        <FieldPair labelA={32} valueA={88} labelB={36} valueB={52} />
        <FieldPair labelA={48} valueA={96} labelB={48} valueB={80} />
        <div className="space-y-1.5">
          <div className="h-3 w-28 rounded bg-gray-200" />
          <div className="h-4 w-24 rounded bg-gray-200" />
        </div>
      </div>

      {/* About card */}
      <div className="rounded-xl border border-gray-100 p-5 space-y-3">
        <div className="flex items-center gap-2">
          <div className="h-4 w-4 rounded bg-gray-200" />
          <div className="h-4 w-16 rounded bg-gray-200" />
        </div>
        <div className="h-3.5 w-48 rounded bg-gray-200" />
      </div>
    </Skeleton>
  </div>
)

export default LoanOfficerDetailsSkeleton
